<template>
  <div class="jobdot" style="position: relative">
    <el-tooltip effect="dark" placement="bottom-start" class="cursor-pointer">
      <span slot="content">
        {{ explanation }}
        <span v-if="job.job.lastRunAt">
          - Executou {{ job.job.lastRunAt | FormatDate("longtime") }}</span>
      </span>
      <!-- <v-icon v-if="dotClass" class="status-dot no-selection" :class="dotClass">fiber_manual_record</v-icon> -->
      <transition name="slide-y-reverse-transition">
        <v-icon
          v-if="job.scheduled"
          key="schedule"
          light
          color="amber"
          class="jobdot-icon"
        >
          schedule
        </v-icon>

        <v-icon
          v-else-if="job.failed"
          key="close"
          light
          color="red"
          class="jobdot-icon"
        >
          close
        </v-icon>

        <v-icon
          v-else-if="job.completed"
          key="check"
          light
          color="green"
          class="jobdot-icon"
        >
          check
        </v-icon>

        <v-icon
          v-else-if="job.running"
          key="refresh"
          light
          color="blue"
          class="rotate jobdot-icon"
        >
          refresh
        </v-icon>
      </transition>
    </el-tooltip>
  </div>

  <!-- <el-tooltip v-if="job.job.nextRunAt" effect="dark" placement="bottom-start">
          <span slot="content">
            {{ job.job.nextRunAt | FormatDate('fromNow') }}
          </span>
        </el-tooltip> -->
</template>

<script>
import _ from "lodash";

export default {
  name: "JobDot",

  props: {
    job: {
      type: Object,
      required: true,
    },

    tooltip: {
      type: Boolean,
      default: true,
    },
  },

  data: function () {
    return {};
  },

  computed: {
    allStatus() {
      return ["scheduled", "completed", "failed", "running", "queued"];
    },

    statuses() {
      return _(this.job)
        .pickBy((value, key) => value && this.allStatus.includes(key))
        .keys()
        .value();
    },

    mainStatus() {
      for (const status of this.allStatus) {
        if (this.statuses.includes(status)) return status;
      }

      return "queued";
    },

    dotClass() {
      return (
        {
          failed: "red-dot",
          running: "blue-dot",
          scheduled: "yellow-dot",
          completed: "green-dot",
          queued: "grey-dot",
        }[this.mainStatus] || "grey-dot"
      );
    },

    explanation() {
      return this.statuses.join(", ");
    },
  },

  created: function () {},
};
</script>

<style scoped>
.jobdot {
  width: 16px;
  height: 16px;
}

.jobdot-icon {
  font-size: 16px !important;
  position: absolute;
  width: 16px;
  height: 16px;
}

/*.status-dot {
  transition: color 0.5s;
  font-size: 16px;
}

.red-dot {
  color: #ec3554 !important;
}

.yellow-dot {
  color: #f5b919 !important;
}

.green-dot {
  color: #71da97 !important;
}

.blue-dot {
  color: #55d0e9 !important;
}

.grey-dot {
  color: #dcdcdc !important;
}
*/
</style>



// WEBPACK FOOTER //
// src/admin/Scheduler/JobDot.vue